import { registerComponent } from '@gig/magic-common';
import DualBalanceComponent from './dual-balance.vue.js';

var DualBalance = registerComponent(DualBalanceComponent);

export { DualBalance };
